import './App.css';
import {BrowserRouter, Navigate, Routes, Route} from 'react-router-dom';
import Calendar from "./component/calendar/Calendar";
import Info from "./component/info/Info";
import NotFound from "./component/error/NotFound";
import Namedays from "./component/nameday/Namedays";
import Nameday from "./component/nameday/Nameday";
import AppNavbar from "./component/navbar/AppNavbar";
import {currentMonthLink} from "./appUtil";
import {setMomentLocale} from "./moment/momentFormat";
import {Analytics} from '@vercel/analytics/react';
import { ThemeProvider } from './context/ThemeContext';


function App() {
    setMomentLocale();
    return (
        <ThemeProvider>
            <div className="App">
                <BrowserRouter>
                    <AppNavbar/>
                    <Routes>
                        <Route path='sitemap.xml'/>
                        <Route path='' element={<Navigate to={currentMonthLink}/>} />
                        <Route path='info' element={<Info/>}/>
                        <Route path='imieniny/:name' element={<Nameday/>}/>
                        <Route path='imieniny' element={<Namedays/>}/>
                        <Route path='nie-znaleziono' element={<NotFound/>}/>
                        <Route path=':date' element={<Calendar/>}/>
                        <Route path='*' element={<NotFound/>}/>
                    </Routes>
                </BrowserRouter>
                <Analytics />
            </div>
        </ThemeProvider>
    )
}

export default App;
